import React, { useState, useEffect, useRef, useContext } from "react";
import Axios from "../../Axios/Axios";
import "./Header.css";
import "./style.css";
import { toast } from "react-toastify";
import { Urls } from "../../Urls";
import { withRouter, NavLink, useHistory, useLocation } from "react-router-dom";
import "./../Payment/Checkout.css";
import PopupModal from "../Shared/PopupModal/PopupModal";
import styles from "./newheader.module.css"
import {
  Activity,
  currentRequestTimeStamp,
  ModuleNames,
  encryptor,
  isMobile,
  RoutePaths,
} from "../../Constants";
import { PROCURE_URLS, DC_URL } from "../../Urls";
import ParametersMapForm from "../MyAccount/GeneratePPT/PPTGenerate/PPTGenerate";
import mixpanel from "mixpanel-browser";
import Loader from "./../Loader/Loader";
import { logout, auth } from "../firebase/firebase";
import { useMixPanelForTracking } from "../../utils/TrackMixPanel";
import { UserApiContext } from "../UserDetailsContext/UserDetailsContext";
import { MyCompanyProfileContext } from "../../MyCompanyProfileContext";
import { getImageSrc } from "../../Utility";
import useViewOnlyAccess from "../../hooks/useViewOnlyAccess";

// Small utility: close menus when you click outside
function useOnClickOutside(ref, handler) {
  useEffect(() => {
    const listener = (e) => {
      if (!ref.current || ref.current.contains(e.target)) return;
      handler(e);
    };
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
}

const Header = ({ appuser, userData, isUserinTeams }) => {
  const [allowedTrackingDashboard, setAllowedTrackingDashboard] = useState("no")
  const [user, setUser] = useState(appuser);
  const [submitText, setsubmitText] = useState("");
  const { userDetails } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const [isAllowed, setisAllowed] = useState("no");
  const [DiscoverNowallowed, setDiscoverNowallowed] = useState("no");
  const [BenchmarkNowAllowed, setBenchmarkNowAllowed] = useState("no");
  const [benchmarkRoute, setBenchmarkRoute] = useState(RoutePaths.BenchmarkNow);
  const [CompareNow, setCompareNow] = useState("no");
  const [indent, setIndent] = useState("no");
  const [invoice, setInvoice] = useState("no");
  const [gigo, setGigo] = useState("no");
  const [HomeSearch, setHomeSearch] = useState("no");
  const [ProcureNow, setProcureNow] = useState("no");
  const [ContractNow, setContractNow] = useState("no");
  const [SynergyNow, setSynergyNow] = useState("no");
  const [searchAllowed, setsearchAllowed] = useState("yes");
  const [Ppt, setPpt] = useState("no");
  const [Benchmark_logistics, setBenchmark_logistics] = useState("no");
  const [audio_input, setaudio_input] = useState(false);
  const [show, setShow] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const isLorriBenchmarkActive = ["/LoRRIBenchmark", "/benchmarknow"].some(
    (r) => r.toLowerCase() === location.pathname.toLowerCase()
  );
  const [RFQCalender, setRFQCalender] = useState("no");
  const [planning, setPlanning] = useState("no");
  const [isDemoUser, setIsDemoUser] = useState(false);
  const { TrackMixPanel } = useMixPanelForTracking(userDetails, companySettingData);
  const { hasModuleAccess: planningModuleAccess, noAccess: planningNoAccess } =
    useViewOnlyAccess("planning");
  const { hasModuleAccess: spotModuleAccess, noAccess: spotNoAccess } =
    useViewOnlyAccess("spot");
  const { hasModuleAccess: reqAccess, noAccess: reqNoAccess } =
    useViewOnlyAccess("indent", "lorri_indent_request");
  const { hasModuleAccess: trackAccess, noAccess: trackNoAccess } =
    useViewOnlyAccess("indent", "lorri_indent_tracking");
  const { noAccess: invoiceNoAccess } = useViewOnlyAccess('invoice');


  // NEW: React-driven UI state (no jQuery/Bootstrap JS needed)
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState(null); // 'transporters' | 'services' | 'operations' | 'profile' | null

  const navRef = useRef(null);
  const transportersRef = useRef(null);
  const servicesRef = useRef(null);
  const operationsRef = useRef(null);
  const profileRef = useRef(null);

  useOnClickOutside(navRef, () => setIsNavOpen(false));
  useOnClickOutside(
    transportersRef,
    () => openMenu === "transporters" && setOpenMenu(null)
  );
  useOnClickOutside(
    servicesRef,
    () => openMenu === "services" && setOpenMenu(null)
  );
  useOnClickOutside(
    operationsRef,
    () => openMenu === "operations" && setOpenMenu(null)
  );
  useOnClickOutside(
    profileRef,
    () => openMenu === "profile" && setOpenMenu(null)
  );

  const toggleMenu = (key) => {
    setOpenMenu((prev) => (prev === key ? null : key));
  };

  const validateServicePolicy = function (policies, service) {
    try {
      if (
        policies[service] &&
        (policies[service]["allowed"] === "yes" ||
          policies[service]["allowed"] === "Yes")
      ) {
        return "yes";
      } else {
        return "no";
      }
    } catch (error) {
      console.log(error);
      return "no";
    }
  };

  useEffect(() => {
    // Guard: element may not exist immediately in strict mode
    const el = document.getElementById("width1000");
    if (el) el.style.justifyContent = "space-around";

    getPolicy();
  }, [userData, userDetails]);

  const getPolicy = () => {
    const userPolicies =
      userDetails && userDetails.policy ? userDetails.policy : {};


    const anyTrackingAllowed = (userPolicies?.indents?.allowed_sim_tracking === "yes" || userPolicies?.indents?.track_and_trace?.allowed === "yes") ? true : false

    // tracking dashboard access with any one of fastag or sim.
    setAllowedTrackingDashboard((userPolicies && userPolicies?.indents && userPolicies?.indents?.allow_lorri_tracking_dashboard && userPolicies?.indents?.allow_lorri_tracking_dashboard === "yes") && (anyTrackingAllowed) ? "yes" : "no")

    setisAllowed(validateServicePolicy(userPolicies, "data_cleaning"));
    setDiscoverNowallowed(validateServicePolicy(userPolicies, "discovernow"));
    setBenchmarkNowAllowed(validateServicePolicy(userPolicies, "benchmarknow"));
    setBenchmarkRoute("/LoRRIBenchmark");
    setIsDemoUser(userDetails?.policy?.type === "demo");
    setCompareNow(validateServicePolicy(userPolicies, "comparenow"));
    setHomeSearch(validateServicePolicy(userPolicies, "home_search"));
    setProcureNow(validateServicePolicy(userPolicies, "procurement"));
    setContractNow(validateServicePolicy(userPolicies, "contractnow"));
    setSynergyNow(validateServicePolicy(userPolicies, "synergynow"));
    setPpt(validateServicePolicy(userPolicies, "ppt"));
    setBenchmark_logistics(
      userData &&
        userData?.policy &&
        userData?.policy?.benchmarknow &&
        userData?.policy?.benchmarknow?.allowed_logistics
        ? userData?.policy?.benchmarknow?.allowed_logistics
        : "no"
    );
    // setsearchAllowed(
    //   userData &&
    //     userData?.policy &&
    //     userData?.policy?.home_search &&
    //     userData?.policy?.home_search?.allowed
    //     ? userData?.policy?.home_search?.allowed
    //     : "no"
    // );
    setIndent(validateServicePolicy(userPolicies, "indents"));
    setGigo(validateServicePolicy(userPolicies, "gatein_gateout"));
    setInvoice(validateServicePolicy(userPolicies, "invoice"));
    setRFQCalender(validateServicePolicy(userPolicies, "rfq_calender"));
    setPlanning(validateServicePolicy(userPolicies, "planning"));
  };

  const Logmeout = () => {
    setShow(true);
    TrackMixPanel({
      ModuleName: "lorri header",
      ScreenName: "user profile",
      Data: `None`,
      Definition: `User has clicked on logout`,
      ActivityType: "event_view",
      UserName: `${localStorage.getItem("userdetails")}`,
      UserEmail: `${localStorage.getItem("useremail")}`,
      CompanyName: `${localStorage.getItem("companyname")}`,
    });
    Activity(
      [
        {
          screen: "user profile",
          module: "lorriheader",
          user_activity: `Logged out successfully`,
          timestamp: currentRequestTimeStamp(),
        },
      ],
      "Sign-Out"
    );
    if (logout(auth)) {
      sessionStorage.removeItem("accessToken");
      localStorage.removeItem("user_name");
    }
    setShow(false);
  };

  const basicUser = (desc) => {
    return (
      <>
        <h5 className="card-text">
          <b style={{ color: "#54af3a", fontSize: "16px" }}>
            You've reached a premium feature.
          </b>
        </h5>
        <span>{desc}</span>
        <h5 className="card-text" style={{ marginTop: "4%" }}>
          <b id="tick">
            <a
              style={{ color: "#393185" }}
              href="https://company.lorri.in/billing"
              target="_blank"
              rel="noopener noreferrer"
            >
              Upgrade now
            </a>
          </b>{" "}
          to unlock this feature or contact us on +91-9867773508 /
          +91-9653620207
        </h5>
      </>
    );
  };

  const demoLockedContent = (desc) => (
    <>
      <h5 className="card-text">
        <b style={{ color: "#54af3a", fontSize: "16px" }}>
          You've reached a premium feature.
        </b>
      </h5>
      <span>{desc}</span>
      <h5 className="card-text" style={{ marginTop: "4%" }}>
        <b id="tick">
          <span
            style={{ color: "#393185", cursor: "pointer" }}
            onClick={() => history.push(RoutePaths.Billing)}
          >
            Upgrade now
          </span>
        </b>{" "}
        to unlock this feature or contact us on +91-9867773508 /
        +91-9653620207
      </h5>
    </>
  );

  const UserProfile = ({ user, userDetails }) => {
    const displayName =
      (userDetails && userDetails.display_name) ||
      localStorage.getItem("user_name") ||
      (localStorage.getItem("useremail")
        ? localStorage
          .getItem("useremail")
          .split("@")[0]
          .replace(/^./, (c) => c.toUpperCase())
        : "");

    return (
      <div
        className="header-user-profile"
        style={{ display: "flex", alignItems: "center" }}
        ref={profileRef}
      >
        <button
          style={{ border: "none", backgroundColor: "#f8f9fa" }}
          className="nav-link"
          id="user_button"
          aria-haspopup="true"
          aria-expanded={openMenu === "profile"}
          onClick={() => toggleMenu("profile")}
        >
          <i
            className="fa fa-user"
          // title={displayName}
          />
          <span className="d-none d-md-inline nav-link dropdown-toggle">
            {displayName}
          </span>
        </button>
        {/* <i className="fa fa-sort-desc fa-1 ml-2" /> */}
        <UserProfilePopUp open={openMenu === "profile"} />
      </div>
    );
  };

  const changePassword = async (e) => {
    mixpanel.track(`User has clicked on change password button`, {
      ApplicationName: `${Urls.mixpanelappname}`,
      ScreenName: "LoRRI-Header",
      ModuleName: "landing_page",
      ActivityLog: "userClickedChangePassword",
      Data: `None`,
      Definition: `User has clicked on change password button`,
      ActivityType: "event_view",
      UserName: `${localStorage.getItem("userdetails")}`,
      UserEmail: `${localStorage.getItem("useremail")}`,
      CompanyName: `${localStorage.getItem("companyname")}`,
    });
    TrackMixPanel({
      ModuleName: "lorri header",
      ScreenName: "change password",
      Data: `None`,
      Definition: "user has clicked on change password button",
    });
    history.push(RoutePaths.ChangePassword);
    setOpenMenu(null);
  };

  const UserProfilePopUp = ({ open }) => {
    const location = useLocation();
    const approvalPaths = [
      RoutePaths.ApprovalProcurement,
      RoutePaths.ApprovalAuction,
      RoutePaths.ApprovalSpot,
      RoutePaths.ApprovalIndent,
    ];

    const isApprovalActive = approvalPaths.includes(location.pathname);

    const companyProfilePaths = [
      RoutePaths.CompanyProfile,
      "/companyprofilenew/team",
      "/companyprofilenew/masters/freightmaster",
      "/companyprofilenew/masters/locationmaster",
      "/companyprofilenew/masters/vendormaster",
      "/companyprofilenew/masters/truckmaster",
      "/companyprofilenew/masters/routemaster",
      "/companyprofilenew/tnc",
      "/companyprofilenew/operations",
      "/companyprofilenew/transporters",
      "/companyprofilenew/settings",
      "/companyprofilenew/rfqdetails",
    ];

    const isCompanyProfileActive = companyProfilePaths.includes(location.pathname);

    return (
      <div
        style={{ zIndex: 4000 }}
        className={`user-profile-popup dropdown-menu ${open ? "show" : ""}`}
        aria-labelledby="user_button"
      >
        <div className="user-profile-popup-userDetails">
          <ul>
            <li>
              <NavLink
                to={RoutePaths.MyAccount}
                id="my_account_link"
                activeClassName="selected-navigation"
                className="user-profile-popup-userDetails-email"
                rel="noopener noreferrer"
                onClick={() => setOpenMenu(null)}
              >
                My Account
              </NavLink>
            </li>

            <li>
              <NavLink
                to={RoutePaths.Sitemap}
                id="sitemap_link"
                activeClassName="selected-navigation"
                className="user-profile-popup-userDetails-email"
                rel="noopener noreferrer"
                onClick={() => setOpenMenu(null)}
              >
                Sitemap
              </NavLink>
            </li>

            <li>
              <NavLink
                to={RoutePaths.ApprovalProcurement}
                id="approvalcontrol_link"
                className={`user-profile-popup-userDetails-email ${isApprovalActive ? "selected-navigation" : ""
                  }`}
                rel="noopener noreferrer"
                onClick={() => setOpenMenu(null)}
              >
                Approval Control
              </NavLink>
            </li>

            <li>
              <NavLink
                to={RoutePaths.CompanyProfile}
                id="company_profile_link"
                className={`user-profile-popup-userDetails-email ${isCompanyProfileActive ? "selected-navigation" : ""
                  }`}
                rel="noopener noreferrer"
                onClick={() => setOpenMenu(null)}
              >
                My Company Profile
              </NavLink>
            </li>

            <li>
              <NavLink
                to={RoutePaths.Billing}
                id="billing_link"
                activeClassName="selected-navigation"
                className="user-profile-popup-userDetails-email"
                rel="noopener noreferrer"
                onClick={() => setOpenMenu(null)}
              >
                Billing and Payments
              </NavLink>
            </li>

            <li>
              <NavLink
                to={RoutePaths.LorriMail}
                id="lorri_inmail_link"
                activeClassName="selected-navigation"
                className="user-profile-popup-userDetails-email"
                rel="noopener noreferrer"
                onClick={() => {
                  Activity([
                    {
                      screen: "Lorri Inmail",
                      module: "Lorri Inmail",
                      user_activity: "Lorri Inmail",
                      timestamp: currentRequestTimeStamp(),
                    },
                  ]);
                  mixpanel.track(`User has clicked on lorri mail`, {
                    ApplicationName: `${Urls.mixpanelappname}`,
                    ScreenName: "LoRRI-Header",
                    ModuleName: "lorri_mail",
                    ActivityLog: `userClickedLorriMail`,
                    Data: `None`,
                    Definition: `User has clicked on lorri mail`,
                    ActivityType: "event_view",
                    UserName: `${localStorage.getItem("userdetails")}`,
                    UserEmail: `${localStorage.getItem("useremail")}`,
                    CompanyName: `${localStorage.getItem("companyname")}`,
                  });
                  setOpenMenu(null);
                }}
              >
                LoRRI-Mail
              </NavLink>
            </li>
            <li>
              <NavLink
                to={RoutePaths.Dashboard}
                id="dashboard_link"
                activeClassName="selected-navigation"
                className="user-profile-popup-userDetails-email"
                rel="noopener noreferrer"
                onClick={() => setOpenMenu(null)}
              >
                LoRRI Dashboard
              </NavLink>
            </li>

            <li>
              <NavLink
                to={RoutePaths.ChangePassword}
                id="change_password_link"
                activeClassName="selected-navigation"
                className="user-profile-popup-userDetails-email"
                style={{
                  color: "black",
                  textDecoration: "none",
                  fontSize: "13px",
                }}
                onClick={(e) => {
                  changePassword(e);
                  setOpenMenu(null);
                }}
              >
                Change Password
              </NavLink>
            </li>

            <hr
              style={{
                marginTop: "0px",
                marginBottom: "5px",
                border: 0,
                borderTop: "1px solid #eee",
                fontSize: "13px",
              }}
            />

            <li>
              <div style={{ fontSize: "large" }}>
                <button
                  className="user-profile-popup-userDetails-email"
                  onClick={() => {
                    setOpenMenu(null);
                    Logmeout();
                  }}
                  id="logout_link"
                  style={{
                    border: "none",
                    backgroundColor: "white",
                    padding: "0%",
                    cursor: "pointer",
                  }}
                >
                  <span style={{ color: "#2e3192", fontSize: "13px" }}>
                    <i className="fas fa-power-off" />
                    &nbsp; Logout
                  </span>
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>
    );
  };

  const premiumPlanClicked = () => {
    Activity([
      {
        screen: "Header",
        module: "UpgradeNow",
        user_activity: "Premium Plan button clicked on header",
        timestamp: currentRequestTimeStamp(),
      },
    ]);
    mixpanel.track(`User has clicked on premium plan button`, {
      ApplicationName: `${Urls.mixpanelappname}`,
      ScreenName: "LoRRI-Header",
      ModuleName: "landing_page",
      ActivityLog: "userClickedPremiumPlan",
      Data: `None`,
      Definition: `User has clicked on premium plan button`,
      ActivityType: "event_view",
      UserName: `${localStorage.getItem("userdetails")}`,
      UserEmail: `${localStorage.getItem("useremail")}`,
      CompanyName: `${localStorage.getItem("companyname")}`,
    });
  };

  const myAccountClicked = () => {
    mixpanel.track(`User has clicked on my account button`, {
      ApplicationName: `${Urls.mixpanelappname}`,
      ScreenName: "LoRRI-Header",
      ModuleName: "my_account",
      ActivityLog: "userClickedMyAccount",
      Data: `None`,
      Definition: `User has clicked on my account button`,
      ActivityType: "event_view",
      UserName: `${localStorage.getItem("userdetails")}`,
      UserEmail: `${localStorage.getItem("useremail")}`,
      CompanyName: `${localStorage.getItem("companyname")}`,
    });
  };

  const onSearchSubmit = (val, from) => {
    Activity([
      {
        screen: "LoRRI-Search",
        module: "Home-Search",
        user_activity: `Search Query: ${submitText}`,
        timestamp: currentRequestTimeStamp(),
      },
    ]);
    if (audio_input) {
      setaudio_input(false);
      const moduleNames = ModuleNames;
      if (moduleNames[0].Benchmark.includes(submitText.toLowerCase())) {
        history.push({ pathname: RoutePaths.FreightRates });
      } else if (moduleNames[0].CompareNow.includes(submitText.toLowerCase())) {
        history.push({ pathname: RoutePaths.CompareNow });
      } else if (
        moduleNames[0].DiscoverNow.includes(submitText.toLowerCase())
      ) {
        history.push({ pathname: RoutePaths.DiscoverNow });
      } else if (
        moduleNames[0].LocationDashboard.includes(submitText.toLowerCase())
      ) {
        history.push({ pathname: RoutePaths.Location });
      } else if (
        moduleNames[0].LogisticsNow.includes(submitText.toLowerCase())
      ) {
        window.open(
          `https://www.logisticsnow.in`,
          "_blank",
          "noopener,noreferrer"
        );
      } else if (
        moduleNames[0].Procurement.includes(submitText.toLowerCase())
      ) {
        window.open(
          `https://www.procure.lorri.in`,
          "_blank",
          "noopener,noreferrer"
        );
      } else {
        Axios.post(`${Urls.search_results}`, {})
          .then((res) => {
            const payload = {
              pathname: RoutePaths.SearchResults,
              state: {
                updated: window.location.pathname === "/SearchResults",
                data: res.data.data,
                searchquery: val ? val.location_name : submitText,
              },
            };
            history.push(payload);
            setShow(false);
          })
          .catch((err) => {
            console.log(err);
            setShow(false);
          });
      }
    } else {
      const moduleNames = ModuleNames;
      if (moduleNames[0].Benchmark.includes(submitText.toLowerCase())) {
        history.push({ pathname: RoutePaths.BenchmarkNow });
      } else if (moduleNames[0].CompareNow.includes(submitText.toLowerCase())) {
        history.push({ pathname: RoutePaths.CompareNow });
      } else if (
        moduleNames[0].DiscoverNow.includes(submitText.toLowerCase())
      ) {
        history.push({ pathname: RoutePaths.DiscoverNow });
      } else if (
        moduleNames[0].LocationDashboard.includes(submitText.toLowerCase())
      ) {
        history.push({ pathname: RoutePaths.LocationDashboard });
      } else if (
        moduleNames[0].LogisticsNow.includes(submitText.toLowerCase())
      ) {
        window.open(
          `https://www.logisticsnow.in`,
          "_blank",
          "noopener,noreferrer"
        );
      } else if (
        moduleNames[0].Procurement.includes(submitText.toLowerCase())
      ) {
        window.open(
          `https://www.procure.lorri.in`,
          "_blank",
          "noopener,noreferrer"
        );
      } else {
        if (val) {
          if (val.transporter_id !== undefined && from === "autocomplete") {
            const a = document.createElement("a");
            a.href = `https://company.lorri.in/tpmp/${encryptor(
              val.transporter_id,
              true
            )}`;
            a.target = "_blank";
            a.rel = "noopener";
            a.click();
          } else {
            setShow(true);
            Axios.post(`${Urls.search_results}`, {
              text:
                val && val.location_name
                  ? val.location_name.split(",")[0]
                  : val.name
                    ? val.name
                    : submitText,
            })
              .then((res) => {
                history.push({
                  pathname: RoutePaths.SearchResults,
                  state: {
                    data: res.data.data,
                    searchquery:
                      val && val.location_name ? val.location_name : submitText,
                  },
                });
                setShow(false);
              })
              .catch((err) => {
                console.log(err);
                setShow(false);
              });
          }
        } else {
          setShow(true);
          if (submitText) {
            Axios.post(`${Urls.search_results}`, {
              text: val ? val.location_name : submitText,
            })
              .then((res) => {
                history.push({
                  pathname: RoutePaths.SearchResults,
                  state: {
                    data: res.data.data,
                    searchquery: val ? val.location_name : submitText,
                  },
                });
                setShow(false);
              })
              .catch((err) => {
                console.log(err);
                setShow(false);
              });
          } else {
            setShow(false);
            toast.info("Search results cannot be empty");
          }
        }
      }
    }
  };

  return (
    <div>
      <Loader show={show} message="Loading Details" />
      <nav
        className="navbar navbar-expand-lg navbar-light bg-light"
        style={{ zIndex: 999 }}
        ref={navRef}
      >
        <span className="navbar-brand" href="#">
          <NavLink to={RoutePaths.MyTransporters} rel="noopener noreferrer">
            <img src={Urls.LorriLogoLogin} alt="LoRRI Logo" style={{ height: "45px" }} />
          </NavLink>
        </span>

        {/* Mobile hamburger — now toggles via React state */}
        <button
          id="hamburger"
          className="navbar-toggler"
          type="button"
          aria-controls="navbarSupportedContent"
          aria-expanded={isNavOpen}
          aria-label="Toggle navigation"
          onClick={() => setIsNavOpen((s) => !s)}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div
          className={`collapse navbar-collapse ${isNavOpen ? "show" : ""}`}
          id="navbarSupportedContent"
        >
          <ul id="width1000" className="navbar-nav mr-auto">
            {BenchmarkNowAllowed === "yes" || Benchmark_logistics === "yes" ? (
              <li
                className="nav-item"
                id="navbarDropdown_benchmark"
                style={{
                  paddingLeft: "0%",
                  paddingRight: "0%",
                  paddingTop: "1px",
                }}
              >
                <span className="nav-link">
                  <NavLink
                    id="benchmark_freightrates"
                    to={benchmarkRoute}
                    className={isLorriBenchmarkActive ? "selected-navigation" : ""}
                    style={{
                      color: "#2e3192",
                      textDecoration: "none",
                      fontSize: "13px",
                    }}
                    rel="noopener noreferrer"
                    onClick={(e) => {
                      e.preventDefault();
                      history.push(benchmarkRoute);
                    }}
                  >
                    LoRRI Benchmark
                  </NavLink>
                </span>
              </li>
            ) : (
              <li>
                <span className="nav-link">
                  <NavLink
                    id="benchmark_freightrates"
                    to={benchmarkRoute}
                    className={isLorriBenchmarkActive ? "selected-navigation" : ""}
                    style={{
                      color: "#2e3192",
                      textDecoration: "none",
                      fontSize: "13px",
                    }}
                    rel="noopener noreferrer"
                    onClick={(e) => {
                      e.preventDefault();
                      history.push(benchmarkRoute);
                    }}
                  >
                    LoRRI Benchmark
                  </NavLink>
                  <div className="hide-me">
                    <div id="popup1" className="">
                      <div className="card-body part1">
                        {basicUser(
                          "Understand your standing in terms of freight rate in the market and find lanes where you can save more!"
                        )}
                      </div>
                    </div>
                  </div>
                </span>
              </li>
            )}

            {ProcureNow === "yes" ? (
              <li
                className="nav-item"
                id="navbarDropdown_benchmark"
                style={{
                  paddingLeft: "3px",
                  paddingRight: "0%",
                  paddingTop: "1px",
                }}
              >
                <a
                  className="nav-link"
                  id="procure_procurenow"
                  onClick={() => {
                    Activity([
                      {
                        screen: "LoRRI Procure",
                        module: "LoRRI Procure",
                        user_activity: "LoRRI Procure clicked on header",
                        timestamp: currentRequestTimeStamp(),
                      },
                    ]);
                  }}
                  href={
                    isUserinTeams ? PROCURE_URLS.LOGIN(sessionStorage.getItem('uid')) : undefined
                  }
                  target="_self"
                  style={{
                    color: "#2e3192",
                    textDecoration: "none",
                    marginLeft: "10px",
                    fontSize: "13px",
                    cursor: "pointer",
                  }}
                  rel="noopener noreferrer"
                >
                  LoRRI Procure
                </a>
              </li>
            ) : (
              <li
                className="nav-item"
                id="navbarDropdown_benchmark"
                style={{
                  paddingLeft: "0%",
                  paddingRight: "0%",
                  paddingTop: "1px",
                }}
              >
                <button
                  className="nav-link"
                  id="procure_procurenow"
                  disabled={!isUserinTeams}
                  onClick={() => {
                    Activity([
                      {
                        screen: "LoRRI Procure",
                        module: "LoRRI Procure",
                        user_activity: "LoRRI Procure clicked on header",
                        timestamp: currentRequestTimeStamp(),
                      },
                    ]);
                  }}
                  target="_self"
                  style={{
                    color: "#2e3192",
                    textDecoration: "none",
                    marginLeft: "10px",
                    fontSize: "13px",
                    cursor: "not-allowed",
                    border: "none",
                    backgroundColor: "#f8f9fa",
                    marginTop: "1px",
                  }}
                >
                  LoRRI Procure
                </button>
                <div className="hide-me">
                  <div id="popup1" className="">
                    <div className="card-body part1">
                      {basicUser(
                        "Manage and run an end-to-end procurement for all your transportation needs"
                      )}
                    </div>
                  </div>
                </div>
              </li>
            )}

            <li
              className="nav-item"
              id="my_account"
              style={{ marginTop: "1px" }}
            >
              {isDemoUser ? (
                <span className="nav-link">
                  <span
                    className="nav-link-disabled"
                    style={{
                      width: "150px",
                      marginLeft: "10px",
                      color: "#2e3192",
                      textDecoration: "none",
                      fontSize: "13px",
                      paddingLeft: "5px",
                      cursor: "not-allowed",
                    }}
                  >
                    LoRRI Spot
                  </span>
                  <div className="hide-me">
                    <div id="popup1" className="">
                      <div className="card-body part2">
                        {demoLockedContent("Book trucks on-demand and manage your spot freight requirements efficiently.")}
                      </div>
                    </div>
                  </div>
                </span>
              ) : (spotNoAccess ? spotModuleAccess : true) ? (
                <span className="nav-link">
                  <NavLink
                    to={RoutePaths.SpotEnquiries}
                    id="my_account_button"
                    className={
                      window.location.pathname === "/trucks/dashboard" ||
                        window.location.pathname === "/trucks/enquiries" ||
                        window.location.pathname ===
                        "/trucks/transporterenquiries"
                        ? "selected-navigation"
                        : ""
                    }
                    style={{
                      width: "150px",
                      marginLeft: "10px",
                      color: "#2e3192",
                      textDecoration: "none",
                      fontSize: "13px",
                      paddingLeft: "5px",
                    }}
                    rel="noopener noreferrer"
                  >
                    LoRRI Spot
                  </NavLink>
                </span>
              ) : (
                <span className="nav-link">
                  <span
                    id="my_account_button"
                    className="nav-link-disabled"
                    style={{
                      width: "150px",
                      marginLeft: "10px",
                      color: "#2e3192",
                      textDecoration: "none",
                      fontSize: "13px",
                      paddingLeft: "5px",
                    }}
                  >
                    LoRRI Spot
                  </span>
                </span>
              )}
            </li>

            {/* Transporters dropdown (React controlled) */}
            <li
              className="nav-item dropdown"
              id="my_transporters"
              style={{
                paddingLeft: "13px",
                paddingRight: "1%",
                paddingTop: "1px",
              }}
              ref={transportersRef}
            >
              <button
                style={{
                  color: "#2e3192",
                  fontSize: "13px",
                  border: "none",
                  backgroundColor: "#f8f9fa",
                  marginTop: "1px",
                  // ,display:"flex",alignItems:'start'
                }}
                className="nav-link dropdown-toggle"
                id="navbarDropdown"
                aria-haspopup="true"
                aria-expanded={openMenu === "transporters"}
                onClick={() => toggleMenu("transporters")}
              >
                <span>Transporter</span>
                {/* <i className="fa fa-sort-desc fa-1 ml-2"/> */}
              </button>
              <div
                style={
                  isNavOpen
                    ? {
                      backgroundColor: "#F9F9FA",
                      outline: "none",
                      border: "none",
                      boxShadow: "0 0 0 0",
                    }
                    : {}
                }
                className={`dropdown-menu ${openMenu === "transporters" ? "show" : ""
                  }`}
                aria-labelledby="navbarDropdown"
              >
                {isDemoUser ? (
                  <>
                    <button
                      className="nav-link"
                      style={{
                        color: "#2e3192",
                        textDecoration: "none",
                        fontSize: "13px",
                        cursor: "not-allowed",
                        border: "none",
                        backgroundColor: "white",
                        marginLeft: "14px",
                      }}
                    >
                      RateNow
                    </button>
                    <div className="hide-me">
                      <div id="popup1" className="">
                        <div className="card-body part2">
                          {demoLockedContent("View and benchmark freight rates across lanes to make better procurement decisions.")}
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <span
                    onClick={() => history.push(RoutePaths.MyTransporters)}
                    className="dropdown-item"
                  >
                    <NavLink
                      to={RoutePaths.MyTransporters}
                      id="my_transporters_button"
                      exact
                      className={
                        window.location.pathname === RoutePaths.MyTransporters
                          ? "selected-navigation"
                          : ""
                      }
                      style={{
                        width: "150px",
                        color: "#2e3192",
                        textDecoration: "none",
                        fontSize: "13px",
                        marginLeft: "0px",
                      }}
                      rel="noopener noreferrer"
                      onClick={() => {
                        setOpenMenu(null);
                      }}
                    >
                      RateNow
                    </NavLink>
                  </span>
                )}

                {isDemoUser ? (
                  <>
                    <button
                      className="nav-link"
                      style={{
                        color: "#2e3192",
                        textDecoration: "none",
                        fontSize: "13px",
                        cursor: "not-allowed",
                        border: "none",
                        backgroundColor: "white",
                        marginLeft: "14px",
                      }}
                    >
                      DiscoverNow
                    </button>
                    <div className="hide-me">
                      <div id="popup1" className="">
                        <div className="card-body part2">
                          {demoLockedContent("Discover the best transporters available in a particular lane, view their detailed profiles, shortlist and compare transporters.")}
                        </div>
                      </div>
                    </div>
                  </>
                ) : DiscoverNowallowed === "yes" ? (
                  <span
                    onClick={() => history.push(RoutePaths.DiscoverNow)}
                    className="dropdown-item"
                  >
                    <NavLink
                      to={RoutePaths.DiscoverNow}
                      id="discovernow_button"
                      className={
                        window.location.pathname === RoutePaths.DiscoverNow
                          ? "selected-navigation"
                          : ""
                      }
                      style={{
                        width: "150px",
                        marginLeft: "0px",
                        color: "#2e3192",
                        textDecoration: "none",
                        fontSize: "13px",
                      }}
                      rel="noopener noreferrer"
                      onClick={() => {
                        setOpenMenu(null);
                        // setIsNavOpen(false);
                      }}
                    >
                      DiscoverNow
                    </NavLink>
                  </span>
                ) : (
                  <>
                    <button
                      className="nav-link"
                      onClick={() => {
                        Activity([
                          {
                            screen: "Header",
                            module: "Header",
                            user_activity: "DiscoverNow clicked on header",
                            timestamp: currentRequestTimeStamp(),
                          },
                        ]);
                      }}
                      style={{
                        color: "#2e3192",
                        textDecoration: "none",
                        fontSize: "13px",
                        cursor: "not-allowed",
                        border: "none",
                        backgroundColor: "white",
                        marginLeft: "14px",
                      }}
                    >
                      DiscoverNow
                    </button>
                    <div className="hide-me">
                      <div id="popup1" className="">
                        <div className="card-body part2">
                          {basicUser(
                            "Discover the best transporters available in a particular lane, view their detailed profiles, shortlist and compare transporters."
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {isDemoUser ? (
                  <>
                    <button
                      className="nav-link"
                      style={{
                        color: "#2e3192",
                        textDecoration: "none",
                        fontSize: "13px",
                        cursor: "not-allowed",
                        border: "none",
                        backgroundColor: "white",
                        marginLeft: "14px",
                      }}
                    >
                      CompareNow
                    </button>
                    <div className="hide-me">
                      <div id="popup1" className="">
                        <div className="card-body part3">
                          {demoLockedContent("Compare transporters basis their financials, business parameters, operational overview and more to make an informed selection.")}
                        </div>
                      </div>
                    </div>
                  </>
                ) : CompareNow === "yes" ? (
                  <span
                    onClick={() => history.push(RoutePaths.CompareNow)}
                    className="dropdown-item"
                  >
                    <NavLink
                      id="comparenow_button"
                      to={RoutePaths.CompareNow}
                      className={
                        window.location.pathname === RoutePaths.CompareNow
                          ? "selected-navigation"
                          : ""
                      }
                      style={{
                        width: "150px",
                        marginLeft: "0px",
                        color: "#2e3192",
                        textDecoration: "none",
                        fontSize: "13px",
                      }}
                      rel="noopener noreferrer"
                      onClick={() => {
                        setOpenMenu(null);
                        // setIsNavOpen(false);
                      }}
                    >
                      CompareNow
                    </NavLink>
                  </span>
                ) : (
                  <>
                    <button
                      className="nav-link"
                      onClick={() => {
                        Activity([
                          {
                            screen: "Header",
                            module: "Header",
                            user_activity: "CompareNow clicked on header",
                            timestamp: currentRequestTimeStamp(),
                          },
                        ]);
                      }}
                      style={{
                        color: "#2e3192",
                        textDecoration: "none",
                        fontSize: "13px",
                        cursor: "not-allowed",
                        border: "none",
                        backgroundColor: "white",
                        marginLeft: "14px",
                      }}
                    >
                      CompareNow
                    </button>
                    <div className="hide-me">
                      <div id="popup1" className="">
                        <div className="card-body part3">
                          {basicUser(
                            "Compare Transporters basis their General Information, Financials, Business Parameters, Operational Overview, Customer Details, and other such miscellaneous parameters. Make an informed decision of transporter selection basis the aforementioned parameters."
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {isDemoUser ? (
                  <>
                    <button
                      className="nav-link"
                      style={{
                        color: "#2e3192",
                        textDecoration: "none",
                        fontSize: "13px",
                        cursor: "not-allowed",
                        border: "none",
                        backgroundColor: "white",
                        marginLeft: "14px",
                      }}
                    >
                      ContractNow
                    </button>
                    <div className="hide-me">
                      <div id="popup1" className="">
                        <div className="card-body part41">
                          {demoLockedContent("Get all information for your transporters on a single click.")}
                        </div>
                      </div>
                    </div>
                  </>
                ) : ContractNow === "yes" ? (
                  <span
                    onClick={() => history.push(RoutePaths.ContractNow)}
                    className="dropdown-item"
                  >
                    <NavLink
                      id="procure_contractnow"
                      to={RoutePaths.ContractNow}
                      className={
                        window.location.pathname === RoutePaths.ContractNow
                          ? "selected-navigation"
                          : ""
                      }
                      style={{
                        width: "150px",
                        marginLeft: "0px",
                        color: "#2e3192",
                        textDecoration: "none",
                        fontSize: "13px",
                      }}
                      rel="noopener noreferrer"
                      onClick={() => {
                        setOpenMenu(null);
                        // setIsNavOpen(false);
                      }}
                    >
                      ContractNow
                    </NavLink>
                  </span>
                ) : (
                  <>
                    <button
                      className="nav-link"
                      onClick={() => {
                        Activity([
                          {
                            screen: "Header",
                            module: "Header",
                            user_activity: "ContractNow clicked on header",
                            timestamp: currentRequestTimeStamp(),
                          },
                        ]);
                      }}
                      style={{
                        color: "#2e3192",
                        textDecoration: "none",
                        fontSize: "13px",
                        cursor: "not-allowed",
                        border: "none",
                        backgroundColor: "white",
                        marginLeft: "14px",
                      }}
                    >
                      ContractNow
                    </button>
                    <div className="hide-me">
                      <div id="popup1" className="">
                        <div className="card-body part41">
                          {basicUser(
                            "Get all information for your transporters on single click."
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {isDemoUser ? (
                  <>
                    <button
                      className="nav-link"
                      style={{
                        color: "#2e3192",
                        textDecoration: "none",
                        fontSize: "13px",
                        cursor: "not-allowed",
                        border: "none",
                        backgroundColor: "white",
                        marginLeft: "14px",
                        marginTop: "-4px",
                      }}
                    >
                      Search Transporters
                    </button>
                    <div className="hide-me">
                      <div id="popup1" className="">
                        <div className="card-body part4">
                          {demoLockedContent("Search from hundreds of transporters as per your requirements.")}
                        </div>
                      </div>
                    </div>
                  </>
                ) : HomeSearch === "yes" ? (
                  <span
                    onClick={() => history.push(RoutePaths.SearchEngine)}
                    className="dropdown-item"
                  >
                    <NavLink
                      to={RoutePaths.SearchEngine}
                      id="searchengine_button"
                      className={
                        window.location.pathname === RoutePaths.SearchEngine
                          ? "selected-navigation"
                          : ""
                      }
                      style={{
                        width: "150px",
                        marginLeft: "0px",
                        color: "#2e3192",
                        textDecoration: "none",
                        fontSize: "13px",
                      }}
                      rel="noopener noreferrer"
                      onClick={() => {
                        setOpenMenu(null);
                        // setIsNavOpen(false);
                      }}
                    >
                      Search Transporters
                    </NavLink>
                  </span>
                ) : (
                  <>
                    <button
                      className="nav-link"
                      onClick={() => {
                        Activity([
                          {
                            screen: "Header",
                            module: "Header",
                            user_activity:
                              "Search Transporters clicked on header",
                            timestamp: currentRequestTimeStamp(),
                          },
                        ]);
                      }}
                      style={{
                        color: "#2e3192",
                        textDecoration: "none",
                        fontSize: "13px",
                        cursor: "not-allowed",
                        border: "none",
                        backgroundColor: "white",
                        marginLeft: "14px",
                        marginTop: "-4px",
                      }}
                    >
                      Search Transporters
                    </button>
                    <div className="hide-me">
                      <div id="popup1" className="">
                        <div className="card-body part4">
                          {basicUser(
                            "Search from hundreds of transporters as per your requirements."
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </li>

            {/* Services/Analytics dropdown (React controlled) */}
            <li
              className="nav-item dropdown"
              id="services"
              style={{ paddingLeft: "4px", paddingTop: "1px" }}
              ref={servicesRef}
            >
              <button
                style={{
                  color: "#2e3192",
                  fontSize: "13px",
                  border: "none",
                  backgroundColor: "#f8f9fa",
                  marginTop: "1px",
                  // display: "flex",
                  // justifyItems: "center",
                }}
                className="nav-link dropdown-toggle"
                id="navbarDropdown_services"
                aria-haspopup="true"
                aria-expanded={openMenu === "services"}
                onClick={() => toggleMenu("services")}
              >
                <span>Analytics</span>
                {/* <i className="fa fa-sort-desc fa-1 ml-2" /> */}
              </button>
              <div
                style={
                  isNavOpen
                    ? {
                      backgroundColor: "#F9F9FA",
                      outline: "none",
                      border: "none",
                      boxShadow: "0 0 0 0",
                    }
                    : {}
                }
                className={`dropdown-menu ${openMenu === "services" ? "show" : ""
                  }`}
                aria-labelledby="navbarDropdown_services"
              >
                {isDemoUser ? (
                  <>
                    <button
                      className="nav-link"
                      style={{
                        color: "#2e3192",
                        textDecoration: "none",
                        fontSize: "13px",
                        cursor: "not-allowed",
                        border: "none",
                        backgroundColor: "white",
                        marginLeft: "14px",
                      }}
                    >
                      Strategic Services
                    </button>
                    <div className="hide-me">
                      <div id="popup1" className="">
                        <div className="card-body part5">
                          {demoLockedContent("Upload your transportation data and sign-up for collaboration with other partners.")}
                        </div>
                      </div>
                    </div>
                  </>
                ) : SynergyNow === "yes" ? (
                  <span
                    onClick={() => history.push(RoutePaths.SynergyNow)}
                    className="dropdown-item"
                  >
                    <NavLink
                      id="services_synergynow"
                      to={RoutePaths.SynergyNow}
                      className={
                        window.location.pathname === RoutePaths.SynergyNow
                          ? "selected-navigation"
                          : ""
                      }
                      style={{
                        width: "150px",
                        marginLeft: "0px",
                        color: "#2e3192",
                        textDecoration: "none",
                        fontSize: "13px",
                      }}
                      rel="noopener noreferrer"
                      onClick={() => {
                        setOpenMenu(null);
                        // setIsNavOpen(false);
                      }}
                    >
                      Strategic Services
                    </NavLink>
                  </span>
                ) : (
                  <>
                    <button
                      className="nav-link"
                      onClick={() => {
                        Activity([
                          {
                            screen: "Header",
                            module: "Header",
                            user_activity:
                              "Strategic Services clicked on header",
                            timestamp: currentRequestTimeStamp(),
                          },
                        ]);
                      }}
                      style={{
                        color: "#2e3192",
                        textDecoration: "none",
                        fontSize: "13px",
                        cursor: "not-allowed",
                        border: "none",
                        backgroundColor: "white",
                        marginLeft: "14px",
                      }}
                    >
                      Strategic Services
                    </button>
                    <div className="hide-me">
                      <div id="popup1" className="">
                        <div className="card-body part5">
                          {basicUser(
                            "Upload your transportation data and sign-up for collaboration with other partners."
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {isDemoUser ? (
                  <>
                    <button
                      className="nav-link"
                      style={{
                        color: "#2e3192",
                        textDecoration: "none",
                        fontSize: "13px",
                        cursor: "not-allowed",
                        border: "none",
                        backgroundColor: "white",
                        marginLeft: "14px",
                      }}
                    >
                      Analytics PPT
                    </button>
                    <div className="hide-me">
                      <div id="popup1" className="">
                        <div className="card-body part6">
                          {demoLockedContent("With one time configuration, generate insightful PowerPoint presentations within minutes for your meetings every month.")}
                        </div>
                      </div>
                    </div>
                  </>
                ) : Ppt === "yes" ? (
                  <>
                    <span
                      onClick={() => {
                        const btn = document.getElementById(
                          "PPT_Generation_Wizard"
                        );
                        // trigger the PopupModal button without jQuery
                        if (btn) btn.click();
                        setOpenMenu(null);
                        // setIsNavOpen(false);
                      }}
                      className="dropdown-item"
                    >
                      <button
                        id="services_synergynow"
                        style={{
                          marginLeft: "-6px",
                          border: "none",
                          color: "#2e3192",
                          textDecoration: "none",
                          cursor: "pointer",
                          fontSize: "13px",
                          // backgroundColor: "white",
                        }}
                        className="ppt-class"
                      >
                        <span>Analytics PPT</span>
                      </button>
                    </span>
                    <PopupModal
                      buttonLabel={"AnalyticsPPT"}
                      style={{
                        color: "#2e3192",
                        textDecoration: "none",
                        background: "white",
                        float: "left",
                        display: "none",
                        marginLeft: "0px",
                        textAlign: "left",
                        fontSize: "13px",
                      }}
                      activityName="Analytics PPT Modal clicked"
                      screenName="Analytics PPT"
                      moduleName="Analytics PPT"
                      buttonClass="contact_us_button btn btn-light"
                      content={<ParametersMapForm />}
                      id={"PPT_Generation_Wizard"}
                      showLogo={true}
                      title={`Analytics PPT Wizard`}
                    />
                  </>
                ) : (
                  <>
                    <button
                      className="nav-link"
                      onClick={() => {
                        Activity([
                          {
                            screen: "Header",
                            module: "Header",
                            user_activity: "Analytics PPT clicked on header",
                            timestamp: currentRequestTimeStamp(),
                          },
                        ]);
                      }}
                      style={{
                        color: "#2e3192",
                        textDecoration: "none",
                        fontSize: "13px",
                        cursor: "not-allowed",
                        border: "none",
                        backgroundColor: "white",
                        marginLeft: "14px",
                      }}
                    >
                      Analytics PPT
                    </button>
                    <div className="hide-me">
                      <div id="popup1" className="">
                        <div className="card-body part6">
                          {basicUser(
                            "With one time configuration, generate insightful PowerPoint presentation within minutes for your meetings every month."
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {isDemoUser ? (
                  <>
                    <button
                      className="nav-link"
                      style={{
                        color: "#2e3192",
                        textDecoration: "none",
                        fontSize: "13px",
                        cursor: "not-allowed",
                        border: "none",
                        backgroundColor: "white",
                        marginLeft: "14px",
                      }}
                    >
                      RFQ Calendar
                    </button>
                    <div className="hide-me">
                      <div id="popup1" className="">
                        <div className="card-body part28">
                          {demoLockedContent("Explore and manage your yearly RFQ schedule.")}
                        </div>
                      </div>
                    </div>
                  </>
                ) : RFQCalender === "yes" ? (
                  <span
                    onClick={() => history.push(RoutePaths.RFQCalender)}
                    className="dropdown-item"
                  >
                    <NavLink
                      to={RoutePaths.RFQCalender}
                      id="rfq_calender"
                      className={
                        window.location.pathname === RoutePaths.RFQCalender
                          ? "selected-navigation"
                          : ""
                      }
                      style={{
                        width: "150px",
                        marginLeft: "0px",
                        color: "#2e3192",
                        textDecoration: "none",
                        fontSize: "13px",
                      }}
                      rel="noopener noreferrer"
                      onClick={() => {
                        setOpenMenu(null);
                        // setIsNavOpen(false);
                      }}
                    >
                      RFQ Calendar
                    </NavLink>
                  </span>
                ) : (
                  <>
                    <button
                      className="nav-link"
                      onClick={() => {
                        Activity([
                          {
                            screen: "Header",
                            module: "Header",
                            user_activity: "RFQCalender clicked on header",
                            timestamp: currentRequestTimeStamp(),
                          },
                        ]);
                      }}
                      style={{
                        color: "#2e3192",
                        textDecoration: "none",
                        fontSize: "13px",
                        cursor: "not-allowed",
                        border: "none",
                        backgroundColor: "white",
                        marginLeft: "14px",
                      }}
                    >
                      RFQ Calendar
                    </button>
                    <div className="hide-me">
                      <div id="popup1" className="">
                        <div className="card-body part28">
                          {basicUser("Explore yearly RFQ schedule")}
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {isAllowed === "yes" ? (
                  <a
                    className="dropdown-item"
                    id="services_datacleaning"
                    href={DC_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      width: "150px",
                      marginLeft: "0px",
                      color: "#2e3192",
                      textDecoration: "none",
                      fontSize: "13px",
                    }}
                    onClick={() => {
                      setOpenMenu(null);
                      // setIsNavOpen(false);
                    }}
                  >
                    My Data
                  </a>
                ) : null}
              </div>
            </li>

            <li className="nav-item" style={{ marginTop: "1px" }}>
              {isDemoUser ? (
                <span className="nav-link">
                  <span
                    className="nav-link-disabled"
                    style={{
                      width: "150px",
                      marginLeft: "10px",
                      color: "#2e3192",
                      textDecoration: "none",
                      fontSize: "13px",
                      paddingLeft: "4px",
                      cursor: "not-allowed",
                    }}
                  >
                    Location Dashboard
                  </span>
                  <div className="hide-me">
                    <div id="popup1" className="">
                      <div className="card-body part2">
                        {demoLockedContent("Analyze your shipment locations and get insights on delivery performance across regions.")}
                      </div>
                    </div>
                  </div>
                </span>
              ) : (
                <span
                  onClick={() => history.push(RoutePaths.LocationDashboard)}
                  className="nav-link"
                >
                  <NavLink
                    to={RoutePaths.LocationDashboard}
                    id="location_analysis_button"
                    className={
                      window.location.pathname === RoutePaths.LocationDashboard
                        ? "selected-navigation"
                        : ""
                    }
                    style={{
                      width: "150px",
                      marginLeft: "10px",
                      color: "#2e3192",
                      textDecoration: "none",
                      fontSize: "13px",
                      paddingLeft: "4px",
                    }}
                    rel="noopener noreferrer"
                  >
                    Location Dashboard
                  </NavLink>
                </span>
              )}
            </li>

            {/* Operations dropdown (React controlled) */}
            <li
              className="nav-item dropdown"
              id="operations_button"
              style={{
                paddingLeft: "1%",
                paddingRight: "5px",
                paddingTop: "1px",
              }}
              ref={operationsRef}
            >
              <button
                style={{
                  color: "#2e3192",
                  fontSize: "13px",
                  marginTop: "1px",
                  border: "none",
                  backgroundColor: "#f8f9fa",
                  // display: "flex",
                  // justifyItems: "center",
                }}
                className="nav-link dropdown-toggle"
                id="navbarDropdown"
                aria-haspopup="true"
                aria-expanded={openMenu === "operations"}
                onClick={() => toggleMenu("operations")}
              >
                <span>Operations</span>
                {/* <i className="fa fa-sort-desc fa-1 ml-2" /> */}
              </button>

              {(() => {
                const isIndentActive =
                  location.pathname.startsWith(RoutePaths.IndentRequest) ||
                  location.pathname.startsWith("/indenttracking") ||
                  location.pathname.startsWith(RoutePaths.IndentRequestMobile) ||
                  location.pathname.startsWith("/indents/trackingdashboard") ||
                  location.pathname.startsWith("/trackingdetails");

                const isGigoActive =
                  location.pathname === RoutePaths.GigoGateIn ||
                  location.pathname === "/gigo/preview" ||
                  location.pathname === "/gigo/gateOut";

                const isInvoiceActive = location.pathname.startsWith(RoutePaths.Invoice);

                const isPlanningActive =
                  location.pathname === RoutePaths.PlanningDashboard ||
                  location.pathname === "/planning/upload_file" ||
                  location.pathname === "/planning/load_optimize";

                const isAutoDispatchActive =
                  location.pathname === RoutePaths.CapacityPlanning ||
                  location.pathname === "/capacityplanning/dispatch";

                return (
                  <div
                    style={
                      isNavOpen
                        ? {
                          backgroundColor: "#F9F9FA",
                          outline: "none",
                          border: "none",
                          boxShadow: "0 0 0 0",
                        }
                        : {}
                    }
                    className={`dropdown-menu ${openMenu === "operations" ? "show" : ""
                      }`}
                    aria-labelledby="navbarDropdown"
                  >
                    {isDemoUser ? (
                      <>
                        <span
                          className="dropdown-item nav-link-disabled"
                          style={{ cursor: "not-allowed", color: "#2e3192", fontSize: "13px" }}
                        >
                          LoRRI Indent
                        </span>
                        <div className="hide-me">
                          <div id="popup1" className="">
                            <div className="card-body part7">
                              {demoLockedContent("Manage and track your indent requests end-to-end with real-time visibility.")}
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (reqNoAccess ? reqAccess : true) ||
                      (trackNoAccess ? trackAccess : true) ? (
                      <span
                        onClick={() => history.push(RoutePaths.IndentRequest)}
                        className="dropdown-item"
                      >
                        <NavLink
                          to={RoutePaths.IndentRequest}
                          id="indent_button"
                          exact
                          className={`${isIndentActive ? "selected-navigation" : ""}`}
                          style={{
                            width: "150px",
                            marginLeft: "0px",
                            color: "#2e3192",
                            textDecoration: "none",
                            fontSize: "13px",
                          }}
                          rel="noopener noreferrer"
                          onClick={() => setOpenMenu(null)}
                        >
                          LoRRI Indent
                        </NavLink>
                      </span>
                    ) : (
                      <span
                        className="dropdown-item nav-link-disabled"
                        id="indent_button"
                        style={{
                          width: "150px",
                          marginLeft: "0px",
                          color: "#2e3192",
                          fontSize: "13px",
                          cursor: "not-allowed",
                          opacity: 0.6,
                        }}
                      >
                        LoRRI Indent
                      </span>
                    )}

                    {
                      allowedTrackingDashboard === "yes" && (
                        <span
                          onClick={() => history.push(RoutePaths.TrackingDashboard)}
                          className="dropdown-item"
                        >
                          <NavLink
                            to={RoutePaths.TrackingDashboard}
                            id="tracking_button"
                            exact
                            className={` ${location.pathname === RoutePaths.TrackingDashboard ? "selected-navigation" : ""}`}
                            style={{
                              width: "150px",
                              marginLeft: "0px",
                              color: "#2e3192",
                              textDecoration: "none",
                              fontSize: "13px",
                            }}
                            rel="noopener noreferrer"
                            onClick={() => setOpenMenu(null)}
                          >
                            LoRRI Tracking
                          </NavLink>
                        </span>
                      )}

                    {isDemoUser ? (
                      <>
                        <span
                          className="dropdown-item"
                          style={{ cursor: "not-allowed", color: "#2e3192", fontSize: "13px" }}
                        >
                          Gate-In & Gate-Out
                        </span>
                        <div className="hide-me">
                          <div id="popup1" className="">
                            <div className="card-body part7">
                              {demoLockedContent("Digitize and streamline your plant gate-in and gate-out operations.")}
                            </div>
                          </div>
                        </div>
                      </>
                    ) : gigo === "yes" ? (
                      <span
                        onClick={() => history.push(RoutePaths.GigoGateIn)}
                        className="dropdown-item"
                      >
                        <NavLink
                          to={RoutePaths.GigoGateIn}
                          id="gigo_button"
                          exact
                          className={` ${isGigoActive ? "selected-navigation" : ""}`}
                          style={{
                            width: "150px",
                            marginLeft: "0px",
                            color: "#2e3192",
                            textDecoration: "none",
                            fontSize: "13px",
                          }}
                          rel="noopener noreferrer"
                          onClick={() => setOpenMenu(null)}
                        >
                          Gate-In & Gate-Out
                        </NavLink>
                      </span>
                    ) : (
                      <>
                        <span className="dropdown-item" id="gigo_button"
                          onClick={() => {
                            Activity([
                              {
                                screen: "Header",
                                module: "Header",
                                user_activity: "GateIn & GateOut clicked on header",
                                timestamp: currentRequestTimeStamp(),
                              },
                            ]);
                          }}
                          style={{ cursor: "not-allowed" }}>
                          Gate-In & Gate-Out
                        </span>
                        <div className="hide-me">
                          <div id="popup1" className="">
                            <div className="card-body part7">
                              {basicUser("Explore GateIn & GateOut")}
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    {isDemoUser ? (
                      <>
                        <span
                          className="dropdown-item"
                          style={{ cursor: "not-allowed", color: "#2e3192", fontSize: "13px" }}
                        >
                          LoRRI Invoice
                        </span>
                        <div className="hide-me">
                          <div id="popup1" className="">
                            <div className="card-body part7">
                              {demoLockedContent("Automate your freight invoice processing and reconciliation with ease.")}
                            </div>
                          </div>
                        </div>
                      </>
                    ) : invoice === "yes" ? (
                      !invoiceNoAccess ? (
                        <span
                          onClick={() => history.push(RoutePaths.Invoice)}
                          className="dropdown-item"
                        >
                          <NavLink
                            to={RoutePaths.Invoice}
                            id="invoice_button"
                            exact
                            className={` ${isInvoiceActive ? "selected-navigation" : ""}`}
                            style={{
                              width: "150px",
                              marginLeft: "0px",
                              color: "#2e3192",
                              textDecoration: "none",
                              fontSize: "13px",
                            }}
                            rel="noopener noreferrer"
                            onClick={() => setOpenMenu(null)}
                          >
                            LoRRI Invoice
                          </NavLink>
                        </span>
                      ) : (
                        <span
                          className="dropdown-item nav-link-disabled"
                          id="invoice_button"
                          onClick={() => {
                            Activity([
                              {
                                screen: "Header",
                                module: "Header",
                                user_activity: "LoRRI Invoice clicked on header",
                                timestamp: currentRequestTimeStamp(),
                              },
                            ]);
                          }}
                        >
                          LoRRI Invoice
                        </span>
                      )
                    ) : (
                      <>
                        <span className="dropdown-item" id="invoice_button"
                          onClick={() => {
                            Activity([
                              {
                                screen: "Header",
                                module: "Header",
                                user_activity: "LoRRI Invoice clicked on header",
                                timestamp: currentRequestTimeStamp(),
                              },
                            ]);
                          }}
                          style={{ cursor: "not-allowed" }}>
                          LoRRI Invoice
                        </span>
                        <div className="hide-me">
                          <div id="popup1" className="">
                            <div className="card-body part7">
                              {basicUser("Explore LoRRI Invoice")}
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    {isDemoUser ? (
                      <>
                        <span
                          className="dropdown-item nav-link-disabled"
                          style={{ cursor: "not-allowed", color: "#2e3192", fontSize: "13px" }}
                        >
                          LoRRI Planning
                        </span>
                        <div className="hide-me">
                          <div id="popup1" className="">
                            <div className="card-body part7">
                              {demoLockedContent("Optimize your load planning and vehicle allocation for maximum efficiency.")}
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      planningNoAccess
                        ? planningModuleAccess
                        : planning === "yes"
                    ) ? (
                      <span
                        onClick={() => history.push(RoutePaths.PlanningDashboard)}
                        className="dropdown-item"
                      >
                        <NavLink
                          to={RoutePaths.PlanningDashboard}
                          id="planning_button"
                          exact
                          className={` ${isPlanningActive ? "selected-navigation" : ""}`}
                          style={{
                            width: "150px",
                            marginLeft: "0px",
                            color: "#2e3192",
                            textDecoration: "none",
                            fontSize: "13px",
                          }}
                          rel="noopener noreferrer"
                          onClick={() => setOpenMenu(null)}
                        >
                          LoRRI Planning
                        </NavLink>
                      </span>
                    ) : (
                      <span
                        className="dropdown-item nav-link-disabled"
                        id="planning_button"
                        onClick={() => {
                          Activity([
                            {
                              screen: "Header",
                              module: "Header",
                              user_activity: "LoRRI Planning clicked on header",
                              timestamp: currentRequestTimeStamp(),
                            },
                          ]);
                        }}
                      >
                        LoRRI Planning
                      </span>
                    )}

                    {isDemoUser ? (
                      <>
                        <span
                          className="dropdown-item"
                          style={{ cursor: "not-allowed", color: "#2e3192", fontSize: "13px" }}
                        >
                          LoRRI Auto Dispatch & Planning
                        </span>
                        <div className="hide-me">
                          <div id="popup1" className="">
                            <div className="card-body part7">
                              {demoLockedContent("Automate vehicle dispatch and capacity planning with intelligent algorithms.")}
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      planningNoAccess
                        ? planningModuleAccess
                        : planning === "yes"
                    ) ? (
                      <span
                        onClick={() => history.push(RoutePaths.CapacityPlanning)}
                        className="dropdown-item"
                      >
                        <div className="navlink-wrapper">
                          <NavLink
                            to={RoutePaths.CapacityPlanning}
                            id="capacity_planning_button"
                            exact
                            className={` ${isAutoDispatchActive ? "selected-navigation" : ""}`}
                            style={{
                              width: "200px",
                              marginLeft: "0px",
                              color: "#2e3192",
                              textDecoration: "none",
                              fontSize: "13px",
                            }}
                            rel="noopener noreferrer"
                            onClick={() => setOpenMenu(null)}
                          >
                            LoRRI Auto Dispatch & Planning
                          </NavLink>
                        </div>
                      </span>
                    ) : (
                      <>
                        <span className="dropdown-item" id="capacity_planning_button"
                          onClick={() => {
                            Activity([
                              {
                                screen: "Header",
                                module: "Header",
                                user_activity:
                                  "LoRRI Capacity Management clicked on header",
                                timestamp: currentRequestTimeStamp(),
                              },
                            ]);
                          }}
                          style={{ cursor: "not-allowed" }}>
                          LoRRI Auto Dispatch & Planning
                        </span>
                        <div className="hide-me">
                          <div id="popup1" className="">
                            <div className="card-body part7">
                              {basicUser("Explore LoRRI Capacity Management")}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                );
              })()}
            </li>

            {/* this is commented out, bcoz the autosuggestor calls the lorrisearchazzure api, it is depereceated */}
            {/* {searchAllowed === "yes" ? (
              <li
                className="nav-item dropdown"
                id="services"
                style={{ paddingLeft: "2%" }}
              >
                <Autosuggestor
                  value={submitText}
                  onChange={(e) => setsubmitText(e)}
                  onSelect={(e) => setsubmitText(e)}
                  getResults={(e) => onSearchSubmit(e, "autocomplete")}
                />
                <i
                  id="searchSubmit"
                  onClick={(e) => onSearchSubmit(e, "autocomplete")}
                  className="fas fa-search"
                  style={{
                    cursor: "pointer",
                    color: "#393186",
                    position: "fixed",
                    marginLeft: "11%",
                    marginTop: "-25px",
                  }}
                />
              </li>
            ) : null} */}
          </ul>

          <div className="dropdown-menu" aria-labelledby="navbarDropdown">
            <li className="nav-item" id="my_account">
              <span className="nav-link" onClick={myAccountClicked}>
                <NavLink
                  to={RoutePaths.MyAccount}
                  id="my_account_button"
                  className={
                    window.location.pathname === RoutePaths.MyAccount
                      ? "selected-navigation"
                      : ""
                  }
                  style={{
                    width: "150px",
                    marginLeft: "10px",
                    color: "#2e3192",
                    textDecoration: "none",
                    fontSize: "13px",
                  }}
                  rel="noopener noreferrer"
                >
                  My Account
                </NavLink>
              </span>
            </li>
          </div>

          {/* <div style={{ display: "flex", alignItems: "center", float: "right", marginRight: "10px" }}>
             <div style={{ width: "120%" }}>
              <a
                href="https://company.lorri.in/billing"
                target="_blank"
                onClick={premiumPlanClicked}
                style={
                  isMobile()
                    ? { display: "none" }
                    : { backgroundColor: "#54af3a", color: "white" }
                }
                className="btn btn-sm green"
                rel="noopener noreferrer"
              >
                Premium Plans
              </a>

              <NavLink
                to="/dashboard"
                id="my_account_button"
                className="btn btn-sm btn-primary"
                style={{ marginLeft: "4%" }}
                rel="noopener noreferrer"
              >
                LoRRI Dashboard
              </NavLink>
            </div>
          </div> */}
        </div>

        <div style={{ display: "inline-flex", fontSize: "13px", alignItems: "center" }}>
          {userDetails?.on_request?.show_logo === "yes" && companySettingData?.logo && (
            <div className={styles.logotag}>{" "} <img
              src={getImageSrc(companySettingData.logo)}
              alt={companySettingData?.company_name}
              title={companySettingData?.company_name}
            />
            </div>
          )}
          <UserProfile user={user} userDetails={userDetails} />
        </div>
      </nav>
    </div>
  );
};

export default withRouter(Header);
